import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
	selector: 'app-table-horizontal',
	styleUrls: ['./table-horizontal.component.css'],
	templateUrl: './table-horizontal.component.html'
})
export class TableHorizontalComponent implements OnInit {
	@ViewChild('tableElement') tableElement: ElementRef;
	@Input() tableData: any;

	constructor() {}

	ngOnInit(): void {}
}
